import React from "react";

import {Stack} from "@mui/joy";

// components
import ConfidentialAttachmentCard from "./ConfidentialAttachmentCard";
import ConfidentialAttachmentList from "./ConfidentialAttachmentList";


class ConfidentialAttachmentTab extends React.Component {
    render(){
        return(
            <Stack
                spacing={2}
                sx={{
                    width: '100%',
                }}
            >
                <ConfidentialAttachmentList
                    appId={this.props.appId}
                    appName={this.props.appName}
                    itemComponent={ConfidentialAttachmentCard}
                    create={true}
                />
            </Stack>
        )
    }
}

export default ConfidentialAttachmentTab